const GSM_BASIC = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM_EXTENDED = '^{}\\[~]|€\f';

export type SmsEncoding = 'GSM' | 'UCS2';

export interface SmsSegments {
    encoding: SmsEncoding;
    length: number;
    segments: number;
    limit: number;
}

const unitsOf = (text: string): {encoding: SmsEncoding; length: number} => {
    let gsm = 0;
    for (const char of text) {
        if (GSM_BASIC.includes(char)) gsm += 1;
        else if (GSM_EXTENDED.includes(char)) gsm += 2;
        else return {encoding: 'UCS2', length: text.length};
    }
    return {encoding: 'GSM', length: gsm};
};

export const smsSegments = (text: string): SmsSegments => {
    const {encoding, length} = unitsOf(text);
    const single = encoding === 'GSM' ? 160 : 70;
    const multi = encoding === 'GSM' ? 153 : 67;
    if (length <= single) return {encoding, length, segments: length === 0 ? 0 : 1, limit: single};
    const segments = Math.ceil(length / multi);
    return {encoding, length, segments, limit: segments * multi};
};
